"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselNavigation = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CarouselContext_js_1 = require("./CarouselContext.js");
const index_js_1 = require("../Buttons/index.js");
const CarouselDotsList_js_1 = require("./CarouselDotsList.js");
const index_js_2 = require("../utils/index.js");
/** Button for switching to previous slide */
const PreviousButton = React.forwardRef((props, ref) => {
    const context = React.useContext(CarouselContext_js_1.CarouselContext);
    if (!context) {
        throw new Error('CarouselNavigation should be used inside Carousel');
    }
    const { slideCount, currentIndex, setCurrentIndex, keysPressed, scrollToSlide, } = context;
    return (React.createElement(index_js_1.IconButton, { styleType: 'borderless', size: 'small', tabIndex: -1, "data-pressed": keysPressed['ArrowLeft'] || undefined, ref: ref, ...props, onClick: (e) => {
            var _a;
            const prevIndex = (slideCount + currentIndex - 1) % slideCount;
            setCurrentIndex(prevIndex);
            scrollToSlide.current(prevIndex, { instant: e.detail > 3 });
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } },
        React.createElement(index_js_2.SvgChevronLeft, null)));
});
/** Button for switching to next slide */
const NextButton = React.forwardRef((props, ref) => {
    const context = React.useContext(CarouselContext_js_1.CarouselContext);
    if (!context) {
        throw new Error('CarouselNavigation should be used inside Carousel');
    }
    const { slideCount, currentIndex, setCurrentIndex, keysPressed, scrollToSlide, } = context;
    return (React.createElement(index_js_1.IconButton, { styleType: 'borderless', size: 'small', tabIndex: -1, "data-pressed": keysPressed['ArrowRight'] || undefined, ref: ref, ...props, onClick: (e) => {
            var _a;
            const nextIndex = (slideCount + currentIndex + 1) % slideCount;
            setCurrentIndex(nextIndex);
            scrollToSlide.current(nextIndex, { instant: e.detail > 3 });
            (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } },
        React.createElement(index_js_2.SvgChevronRight, null)));
});
/**
 * The `CarouselNavigation` component by default consists of the `PreviousButton` and `NextButton`
 * shown on the left and right, and the `CarouselDotsList` component shown in the middle.
 *
 * `children` can be specified to override what is shown in this navigation section.
 */
exports.CarouselNavigation = Object.assign(React.forwardRef((props, ref) => {
    const { className, children, ...rest } = props;
    return (React.createElement("nav", { className: (0, classnames_1.default)('iui-carousel-navigation', className), ref: ref, ...rest }, children !== null && children !== void 0 ? children : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'iui-carousel-navigation-left' },
            React.createElement(PreviousButton, null)),
        React.createElement(CarouselDotsList_js_1.CarouselDotsList, null),
        React.createElement("div", { className: 'iui-carousel-navigation-right' },
            React.createElement(NextButton, null))))));
}), { PreviousButton, NextButton });
